export class RangeInput {
  constructor(rangeInput) {
    this.rangeInput = rangeInput;
    this.isChanging = false;

    this.rangeInput.addEventListener("input", () => {
      this.setCSSProperty();
    });

    this.setCSSProperty();
  }

  setCSSProperty() {
    const percent =
      ((this.rangeInput.value - this.rangeInput.min) /
        (this.rangeInput.max - this.rangeInput.min)) *
      100;

    this.rangeInput.style.setProperty("--webkitProgressPercent", `${percent}%`);
  }
}
